import Router from "./Router";
import { useEffect, useState } from "react";
import axios from "axios";
import ServerError from "./components/server/ServerError";

function App() {
  const [isIndia, setIsIndia] = useState(null);
  const [loading, setLoading] = useState(true);
  const [serverError, setServerError] = useState(false);

  // Fetch the user's country using IP-based geolocation
  const checkLocation = async () => {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();

      if (data.country_name === "India") {
        setIsIndia(true);
      } else {
        setIsIndia(true); // false
      }
    } catch (error) {
      console.error("Error fetching location:", error);
      setIsIndia(true); // Default to allow if unable to fetch location
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkLocation();

    // Axios interceptor for catching server errors
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        const isNetworkError =
          error.response === undefined && error.message === "Network Error";

        if (status === 500 || status === 502 || status === 503) {
          const url = error?.config?.url || "";
          const isNonCritical = ["/fee-x", "/validate-coupon", "/pincode_availability", "/active_offers"].some((ep) => url.includes(ep));
          if (!isNonCritical) {
            setServerError(true);
          }
        }
        return Promise.reject(error);
      }
    );

    const handleKeyDown = (e) => {
      if (e.key === 'Backspace') {
        const activeNodeName = document.activeElement.nodeName;
        const isInput = activeNodeName === 'INPUT' || activeNodeName === 'TEXTAREA' || document.activeElement.isContentEditable;
        if (!isInput) {
          e.preventDefault();
          window.history.back();
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      // axios.interceptors.response.eject(interceptor);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div style={{ position: "relative" }}>
      {/* Your website content */}
      <div style={{ filter: isIndia === false ? "blur(5px)" : "none" }}>
        {serverError && <ServerError/>}
        <Router />
      </div>

      {/* Restriction overlay */}
      {isIndia === false && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)", // Semi-transparent background
            color: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <h1>Apologies, this website is unavailable in your region.</h1>
          {/* <p>Please visit us from India to access the content.</p> */}
        </div>
      )}
    </div>
  );
}

export default App;
